import {useMemo} from "react";
import {useCurrentRefinements} from "react-instantsearch";

export const useAmountOfCurrentRefinements=()=>{
    const {items} = useCurrentRefinements();
    return useMemo(() => {
        return items.reduce((total, item) => total + item.refinements.length, 0);
    }, [items])
}